import React, { useState, useEffect } from "react";
import axios from "../../libs/axios";
import { Formik, Form } from "formik";
import TextField from "@mui/material/TextField";
import InputFeild from "../../components/common/NewTextFeild";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import "../Assesment/assesment.css";
import { Button } from "@mui/material";
import ImageUpload from "../../components/common/imageUpload/ImageUpload";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
// import FormLabel from "@mui/material/FormLabel";

export default function SitePhotos({
  formData,
  handlePreviousPage,
  previouscallingBackend,
  setPreviousCallingBackend,
  handleNextPage,
  callingBackend,
  setCallingBackend,
}) {
  const { state } = useLocation();
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const [image1name, setImage1name] = useState("");
  const [image2name, setImage2name] = useState("");
  const [image3name, setImage3name] = useState("");
  const [image4name, setImage4name] = useState("");
  const [image5name, setImage5name] = useState("");
  const [image6name, setImage6name] = useState("");
  const [image7name, setImage7name] = useState("");
  const [image8name, setImage8name] = useState("");
  const [image9name, setImage9name] = useState("");
  const [image10name, setImage10name] = useState("");
  const [image11name, setImage11name] = useState("");
  const [image12name, setImage12name] = useState("");
  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const [image4, setImage4] = useState("");
  const [image5, setImage5] = useState("");
  const [image6, setImage6] = useState("");
  const [image7, setImage7] = useState("");
  const [image8, setImage8] = useState("");
  const [image9, setImage9] = useState("");
  const [image10, setImage10] = useState("");
  const [image11, setImage11] = useState("");
  const [image12, setImage12] = useState("");
  const [image1type, setImage1type] = useState("landscape");
  const [image2type, setImage2type] = useState("landscape");
  const [image3type, setImage3type] = useState("landscape");
  const [image4type, setImage4type] = useState("landscape");
  const [image5type, setImage5type] = useState("landscape");
  const [image6type, setImage6type] = useState("landscape");
  const [image7type, setImage7type] = useState("landscape");
  const [image8type, setImage8type] = useState("landscape");
  const [image9type, setImage9type] = useState("landscape");
  const [image10type, setImage10type] = useState("landscape");
  const [image11type, setImage11type] = useState("landscape");
  const [image12type, setImage12type] = useState("landscape");

  const [initialValues, setInitialValues] = useState({
    image1: "",
    image1name: "",
    image2: "",
    image2name: "",
    image3: "",
    image3name: "",
    image4: "",
    image4name: "",
    image5: "",
    image5name: "",
    image6: "",
    image6name: "",
    image7: "",
    image7name: "",
    image8: "",
    image8name: "",
    image9: "",
    image9name: "",
    image10: "",
    image10name: "",
    image11: "",
    image11name: "",
    image12: "",
    image12name: "",
    image1type: "",
    image2type: "",
    image3type: "",
    image4type: "",
    image5type: "",
    image6type: "",
    image7type: "",
    image8type: "",
    image9type: "",
    image10type: "",
    image11type: "",
    image12type: "",
  });

  const submit = async (e, { resetForm }) => {
    try {
      setCallingBackend(true);
      await axios.put(`/assesment/site_photos/${state.id}`, {
        image1: image1,
        image1name: image1name,
        image2: image2,
        image2name: image2name,
        image3: image3,
        image3name: image3name,
        image4: image4,
        image4name: image4name,
        image5: image5,
        image5name: image5name,
        image6: image6,
        image6name: image6name,
        image7: image7,
        image7name: image7name,
        image8: image8,
        image8name: image8name,
        image9: image9,
        image9name: image9name,
        image10: image10,
        image10name: image10name,
        image11: image11,
        image11name: image11name,
        image12: image12,
        image12name: image12name,
        image1type: image1type || "landscape",
        image2type: image2type || "landscape",
        image3type: image3type || "landscape",
        image4type: image4type || "landscape",
        image5type: image5type || "landscape",
        image6type: image6type || "landscape",
        image7type: image7type || "landscape",
        image8type: image8type || "landscape",
        image9type: image9type || "landscape",
        image10type: image10type || "landscape",
        image11type: image11type || "landscape",
        image12type: image12type || "landscape",
      });
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Site photos saved successfully!",
      });
      setTimeout(
        () =>
          setAlert({
            showAlert: false,
            severity: "success",
            message: "Site photos saved successfully!",
          }),
        handleNextPage(),
        5000
      );
    } catch (error) {
      if (error.response.data === "Site photos already exists") {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Site photos already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Site photos already exists!",
            }),
          5000
        );
      } else if (error.response.status === 401) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Unauthorized Access!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Unauthorized Access!",
            }),
          5000
        );
      } else if (error.response.status === 500) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Server Error!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Server Error!",
            }),
          5000
        );
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Site photos already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Site photos already exists!",
            }),
          5000
        );
      }
    }
  };

  const handleClick = () => {
    setPreviousCallingBackend(true);
    handlePreviousPage();
  };
  useEffect(() => {
    setInitialValues({
      image1: formData?.site_photos?.image1,
      image1name: formData?.site_photos?.image1name,
      image2: formData?.site_photos?.image2,
      image2name: formData?.site_photos?.image2name,
      image3: formData?.site_photos?.image3,
      image3name: formData?.site_photos?.image3name,
      image4: formData?.site_photos?.image4,
      image4name: formData?.site_photos?.image4name,
      image5: formData?.site_photos?.image5,
      image5name: formData?.site_photos?.image5name,
      image6: formData?.site_photos?.image6,
      image6name: formData?.site_photos?.image6name,
      image7: formData?.site_photos?.image7,
      image7name: formData?.site_photos?.image7name,
      image8: formData?.site_photos?.image8,
      image8name: formData?.site_photos?.image8name,
      image9: formData?.site_photos?.image9,
      image9name: formData?.site_photos?.image9name,
      image10: formData?.site_photos?.image10,
      image10name: formData?.site_photos?.image10name,
      image11: formData?.site_photos?.image11,
      image11name: formData?.site_photos?.image11name,
      image12: formData?.site_photos?.image12,
      image12name: formData?.site_photos?.image12name,
    });
    setImage1(formData?.site_photos?.image1);
    setImage2(formData?.site_photos?.image2);
    setImage3(formData?.site_photos?.image3);
    setImage4(formData?.site_photos?.image4);
    setImage5(formData?.site_photos?.image5);
    setImage6(formData?.site_photos?.image6);
    setImage7(formData?.site_photos?.image7);
    setImage8(formData?.site_photos?.image8);
    setImage9(formData?.site_photos?.image9);
    setImage10(formData?.site_photos?.image10);
    setImage11(formData?.site_photos?.image11);
    setImage12(formData?.site_photos?.image12);
    setImage1name(formData?.site_photos?.image1name);
    setImage2name(formData?.site_photos?.image2name);
    setImage3name(formData?.site_photos?.image3name);
    setImage4name(formData?.site_photos?.image4name);
    setImage5name(formData?.site_photos?.image5name);
    setImage6name(formData?.site_photos?.image6name);
    setImage7name(formData?.site_photos?.image7name);
    setImage8name(formData?.site_photos?.image8name);
    setImage9name(formData?.site_photos?.image9name);
    setImage10name(formData?.site_photos?.image10name);
    setImage11name(formData?.site_photos?.image11name);
    setImage12name(formData?.site_photos?.image12name);
    setImage1type(formData?.site_photos?.image1type);
    setImage2type(formData?.site_photos?.image2type);
    setImage3type(formData?.site_photos?.image3type);
    setImage4type(formData?.site_photos?.image4type);
    setImage5type(formData?.site_photos?.image5type);
    setImage6type(formData?.site_photos?.image6type);
    setImage7type(formData?.site_photos?.image7type);
    setImage8type(formData?.site_photos?.image8type);
    setImage9type(formData?.site_photos?.image9type);
    setImage10type(formData?.site_photos?.image10type);
    setImage11type(formData?.site_photos?.image11type);
    setImage12type(formData?.site_photos?.image12type);
  }, [formData]);
  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={submit}
        enableReinitialize
      >
        {({ dirty, isValid }) => {
          return (
            <Form>
              <Grid
                container
                xs={12}
                sx={{
                  padding: "1rem",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p className="formName">Site Photographs</p>
                <Grid container xs={10} spacing={1}>
                  <Grid
                    container
                    item
                    xs={6}
                    spacing={1}
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignContent: "flex-start",
                    }}
                  >
                    <Grid item xs={12}>
                      <FormControl>
                        <Grid item xs={12}>
                          <p className="inputTextP"> Image 1:</p>{" "}
                        </Grid>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          defaultValue="landscape"
                          value={image1type ? image1type : "landscape"}
                          onChange={(event) =>
                            setImage1type(event.target.value)
                          }
                        >
                          <FormControlLabel
                            value="landscape"
                            control={<Radio />}
                            label="Landscape"
                          />
                          <FormControlLabel
                            value="portrait"
                            control={<Radio />}
                            label="Portrait"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <p className="inputTextP">Image 1 name:</p>{" "}
                    </Grid>
                    <Grid item xs={12}>
                      <InputFeild
                        name="image1name"
                        value={image1name}
                        onChange={(event) => {
                          setImage1name(event.target.value);
                        }}
                        component={TextField}
                        variant
                        fullWidth
                        bgColor="#FFFFFF"
                        margin="dense"
                      />{" "}
                    </Grid>
                    <Grid item xs={12}>
                      <ImageUpload
                        setImage={setImage1}
                        image={image1}
                        name="image1"
                      />
                    </Grid>
                  </Grid>
                  {image1 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 2 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image2type ? image2type : "landscape"}
                            onChange={(event) =>
                              setImage2type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 2 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image2name"
                          value={image2name}
                          onChange={(event) => {
                            setImage2name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage2}
                          image={image2}
                          name="image2"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image2 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 3 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image3type ? image3type : "landscape"}
                            onChange={(event) =>
                              setImage3type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 3 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image3name"
                          value={image3name}
                          onChange={(event) => {
                            setImage3name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage3}
                          image={image3}
                          name="image3"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image3 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 4 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image4type ? image4type : "landscape"}
                            onChange={(event) =>
                              setImage4type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 4 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image4name"
                          value={image4name}
                          onChange={(event) => {
                            setImage4name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage4}
                          image={image4}
                          name="image4"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image4 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 5 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image5type ? image5type : "landscape"}
                            onChange={(event) =>
                              setImage5type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 5 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image5name"
                          value={image5name}
                          onChange={(event) => {
                            setImage5name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage5}
                          image={image5}
                          name="image5"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image5 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 6 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image6type ? image6type : "landscape"}
                            onChange={(event) =>
                              setImage6type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 6 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image6name"
                          value={image6name}
                          onChange={(event) => {
                            setImage6name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage6}
                          image={image6}
                          name="image6"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image6 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 7 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultValue="landscape"
                            value={image7type ? image7type : "landscape"}
                            onChange={(event) =>
                              setImage7type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 7 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image7name"
                          value={image7name}
                          onChange={(event) => {
                            setImage7name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage7}
                          image={image7}
                          name="image7"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image7 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 8 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image8type ? image8type : "landscape"}
                            onChange={(event) =>
                              setImage8type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 8 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image8name"
                          value={image8name}
                          onChange={(event) => {
                            setImage8name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage8}
                          image={image8}
                          name="image8"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image8 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 9 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image9type ? image9type : "landscape"}
                            onChange={(event) =>
                              setImage9type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 9 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image9name"
                          value={image9name}
                          onChange={(event) => {
                            setImage9name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage9}
                          image={image9}
                          name="image9"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image9 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 10 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image10type ? image10type : "landscape"}
                            onChange={(event) =>
                              setImage10type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 10 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image10name"
                          value={image10name}
                          onChange={(event) => {
                            setImage10name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage10}
                          image={image10}
                          name="image10"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image10 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 11 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image11type ? image11type : "landscape"}
                            onChange={(event) =>
                              setImage11type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 11 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image11name"
                          value={image11name}
                          onChange={(event) => {
                            setImage11name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage11}
                          image={image11}
                          name="image11"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {image11 && (
                    <Grid
                      container
                      item
                      xs={6}
                      spacing={1}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "flex-start",
                      }}
                    >
                      <Grid item xs={12}>
                        <FormControl>
                          <Grid item xs={12}>
                            <p className="inputTextP"> Image 12 type:</p>{" "}
                          </Grid>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={image12type ? image12type : "landscape"}
                            onChange={(event) =>
                              setImage12type(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="landscape"
                              control={<Radio />}
                              label="Landscape"
                            />
                            <FormControlLabel
                              value="portrait"
                              control={<Radio />}
                              label="Portrait"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <p className="inputTextP">Image 12 name:</p>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <InputFeild
                          name="image12name"
                          value={image12name}
                          onChange={(event) => {
                            setImage12name(event.target.value);
                          }}
                          component={TextField}
                          variant
                          fullWidth
                          bgColor="#FFFFFF"
                          margin="dense"
                        />{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <ImageUpload
                          setImage={setImage12}
                          image={image12}
                          name="image12"
                        />
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    container
                    item
                    xs={12}
                    sx={{
                      alignContent: "center",
                      justifyContent: "space-between",
                      marginTop: "2rem",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => handleClick()}
                      sx={{
                        backgroundColor: "#22345B",
                        textTransform: "capitalize",
                        fontFamily: "serif",
                        borderRadius: "8px",
                        ":hover": { backgroundColor: "#22345B" },
                      }}
                      disabled={previouscallingBackend}
                    >
                      {previouscallingBackend ? (
                        <CircularProgress
                          size={25}
                          sx={{ color: "#22345B", margin: "0 5px" }}
                        />
                      ) : (
                        "Previous"
                      )}
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={
                        !image1 ||
                        (image1 && !image1name) ||
                        (image2 && !image2name) ||
                        (image3 && !image3name) ||
                        (image4 && !image4name) ||
                        (image5 && !image5name) ||
                        (image6 && !image6name) ||
                        (image7 && !image7name) ||
                        (image8 && !image8name) ||
                        (image9 && !image9name) ||
                        (image10 && !image10name) ||
                        (image11 && !image11name) ||
                        (image12 && !image12name) ||
                        callingBackend
                      }
                      sx={{
                        backgroundColor: "#22345B",
                        textTransform: "capitalize",
                        fontFamily: "serif",
                        borderRadius: "8px",
                        ":hover": { backgroundColor: "#22345B" },
                      }}
                    >
                      {callingBackend ? (
                        <CircularProgress
                          size={25}
                          sx={{ color: "#22345B", margin: "0 5px" }}
                        />
                      ) : (
                        "Next"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
